module.exports = __webpack_public_path__ + "static/media/S (123).81139aca.jpg";